class PdpTabs extends HTMLElement {
  static SECTION_SELECTOR = [
    '.shopify-section:has(.pdp-details)',
    '.shopify-section:has(.collapsible-content)',
    '.shopify-section:has(maxton-set-builder)',
  ].join(', ');

  connectedCallback() {
    this.pdpTabsList = this.querySelector('ul');
    const tabItems = [...document.querySelectorAll(PdpTabs.SECTION_SELECTOR)]
      .map((section) => ({ section, title: this.readSectionTitle(section) }))
      .filter(({ title }) => title)
      .map(({ section, title }) => this.createTabItem(section, title));

    this.pdpTabsList.append(...tabItems);
  }

  // Tab title: explicit data attribute first, then the section's visible title
  readSectionTitle(section) {
    return section.querySelector('[data-pdp-tab-title]')?.dataset.pdpTabTitle?.trim() || (section.querySelector('[class*="__title"]')?.innerText ?? '').trim() || '';
  }

  createTabItem(section, title) {
    const listItem = document.createElement('li');
    const pdpTab = document.createElement('pdp-tab');
    pdpTab.targetSection = section;
    pdpTab.dataset.title = title;
    listItem.append(pdpTab);
    return listItem;
  }
}

customElements.define('pdp-tabs', PdpTabs);